// extracted by mini-css-extract-plugin
module.exports = {"root":"_1579c","required":"_3nLFS","icon":"wQ_G4"};